import template from './loansCatalogCardButtons.html';
import controller from './loansCatalogCardButtons.controller';
import './loansCatalogCardButtons.scss';

let loansCatalogCardButtonsComponent = {
  restrict: 'E',
  bindings: {
    onSelectActionCard: '&',
    serviceClosed: '<',
    isMobileApp: '<'
  },
  template,
  controller,
};

export default loansCatalogCardButtonsComponent;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/loansCatalog/loansCatalogCard/loansCatalogCardButtons/loansCatalogCardButtons.component.js